// extracted by mini-css-extract-plugin
export var menuIcon = "_pp-0";
export var menuIconInline = "_pp-1";